import React, { Fragment } from 'react';
import { Greyscale } from 'glints-aries';
import { Icon } from 'glints-aries/lib/@next';

import useConfig from 'src/common/hooks/useConfig';

import getSocialMediaUrl from './getSocialMediaUrl';

const SocialMediaLinkGroup = () => {
  const { country } = useConfig({
    country: 'COUNTRY',
  });
  const socialMediaLink = getSocialMediaUrl(country);
  const iconColor = Greyscale.white;

  return (
    <Fragment>
      {socialMediaLink.instagram && (
        <a
          href={socialMediaLink.instagram}
          target="_blank"
          rel="nofollow noopener noreferrer"
          aria-label="Instagram"
        >
          <Icon
            name="ri-instagram-line"
            fill={iconColor}
            height={30}
            width={30}
          />
        </a>
      )}
      {socialMediaLink.twitter && (
        <a
          href={socialMediaLink.twitter}
          target="_blank"
          rel="nofollow noopener noreferrer"
          aria-label="Twitter"
        >
          <Icon
            name="ri-twitter-x-fill"
            fill={iconColor}
            height={30}
            width={30}
          />
        </a>
      )}
      {socialMediaLink.facebook && (
        <a
          href={socialMediaLink.facebook}
          target="_blank"
          rel="nofollow noopener noreferrer"
          aria-label="Facebook"
        >
          <Icon
            name="ri-facebook-circle-line"
            fill={iconColor}
            height={30}
            width={30}
          />
        </a>
      )}
      {socialMediaLink.linkedin && (
        <a
          href={socialMediaLink.linkedin}
          target="_blank"
          rel="nofollow noopener noreferrer"
          aria-label="LinkedIn"
        >
          <Icon
            name="ri-linkedIn-line"
            fill={iconColor}
            height={30}
            width={30}
          />
        </a>
      )}
      {socialMediaLink.mail && (
        <a
          href={socialMediaLink.mail}
          target="_blank"
          rel="nofollow noopener noreferrer"
          aria-label="Email"
        >
          <Icon name="ri-mail-line" fill={iconColor} height={30} width={30} />
        </a>
      )}
      {socialMediaLink.tiktok && (
        <a
          href={socialMediaLink.tiktok}
          target="_blank"
          rel="nofollow noopener noreferrer"
          aria-label="TikTok"
        >
          <Icon name="ri-tiktok-line" fill={iconColor} height={30} width={30} />
        </a>
      )}
    </Fragment>
  );
};

export default SocialMediaLinkGroup;
